import { render } from "./UnicodeConverter.vue?vue&type=template&id=9b179ede&scoped=true"
import script from "./UnicodeConverter.vue?vue&type=script&lang=js"
export * from "./UnicodeConverter.vue?vue&type=script&lang=js"

import "./UnicodeConverter.vue?vue&type=style&index=0&id=9b179ede&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b179ede"]])

export default __exports__